// extracted by mini-css-extract-plugin
export default {"item":"style_item__KZ-yl","label":"style_label__CNQp5","value":"style_value__oOUKn"};